// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Item_wrapper__1rDWy"};